export const PLAN_SELECT_TEST_ID = {
  text: 'text',
  price: 'price',
};
